import { FC } from 'react';

import { ReactComponent as DeleteIcon } from '~/ui/assets/images/delete.svg';
import variables from '~/ui/assets/styles/colors.module.scss';
import ButtonIcon from '~/ui/components/common/ButtonIcon';
import { IClientOptionTeam } from '~/store/client/types';

import AllocationClientRow from '../../../shared/components/AllocationClientRow/AllocationClientRow';
import MemoField from '../../../shared/components/MemoField/MemoField';
import TeamsField from '../../../shared/components/TeamField/TeamsField';
import { ClientWithAllocation } from '../../../shared/model/types';
import { useAddClientAllocationContext } from '../../context/AddClientAllocationContext';
import useClientAvailabilityMessages from '../../../EditClientAllocation/hooks/validateAllocations/useClientAvailabilityMessages';

interface IProps {
  field: ClientWithAllocation & { id: string };
  clientIdx: number;
  teamMemberIdx: number;
  onRemove: (idx: number) => void;
  availableClientTeams?: IClientOptionTeam[];
  memberId: number;
}

const AllocationClientRowItem: FC<IProps> = ({
  field,
  clientIdx,
  teamMemberIdx,
  memberId,
  onRemove,
  availableClientTeams,
}) => {
  const MEMO_FIELD_NAME = `teamMembersAllocations.${teamMemberIdx}.clientsAllocations.${clientIdx}.memo`;
  const { currentUserRole } = useAddClientAllocationContext();

  const { alertMessage, noteMessage } = useClientAvailabilityMessages({
    clientId: field.clientId,
    memberId,
    teamMemberIdx,
  });

  const client = {
    photo: field.photo,
    name: field.name,
    isResolved: false,
    isCrisis: false,
    clientId: field.clientId,
    teams: availableClientTeams || (field.teams as unknown as IClientOptionTeam[]),
  };

  const handleDelete = () => {
    onRemove(clientIdx);
  };

  return (
    <AllocationClientRow
      client={client}
      alertMessage={alertMessage}
      noteMessage={noteMessage}
      memoField={<MemoField memoFieldName={MEMO_FIELD_NAME} />}
      teamsField={
        field.teams && currentUserRole.isGlobalUser ? (
          <TeamsField
            teams={client.teams}
            selectedTeamId={field.teamId}
            fieldName={`teamMembersAllocations.${teamMemberIdx}.clientsAllocations.${clientIdx}.teamId`}
          />
        ) : undefined
      }
      actions={
        <ButtonIcon onClick={handleDelete}>
          <DeleteIcon width={20} color={variables.colorRed} />
        </ButtonIcon>
      }
    />
  );
};

export default AllocationClientRowItem;
